import { render, staticRenderFns } from "./AppClaim.vue?vue&type=template&id=15afd282&scoped=true"
import script from "./AppClaim.vue?vue&type=script&lang=js"
export * from "./AppClaim.vue?vue&type=script&lang=js"
import style0 from "./AppClaim.vue?vue&type=style&index=0&id=15afd282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15afd282",
  null
  
)

export default component.exports